import { useUploadUserDocument } from '@/queries/use-upload';
import { useCreateUserDocument } from '@/queries/use-user-documents';
import { extractFileNameFromFile } from '@/utils/extract-file-name';
import type { UserDocumentType } from '@carvia/ros-client-types';
import { DateTime } from 'luxon';
import { computed } from 'vue';

export const useUploadAndCreateUserDocument = () => {
  const { mutateAsync: uploadUserDocument, isPending: isUploadingUserDocument } =
    useUploadUserDocument();
  const { mutateAsync: createUserDocument, isPending: isCreatingUserDocument } =
    useCreateUserDocument();

  const isPending = computed(() => isCreatingUserDocument.value || isUploadingUserDocument.value);

  const uploadAndCreateUserDocument = async (
    userId: string,
    file: File,
    type: UserDocumentType,
    documentName: string,
    comment?: string,
  ) => {
    const { suffix, fileName } = extractFileNameFromFile(file);
    const timestamp = DateTime.now().toISO().replace(/:/g, '-');
    const finalFileName = `${fileName}-${timestamp}.${suffix}`;
    const { fileKey } = await uploadUserDocument({
      file: file,
      params: { userId, fileName: finalFileName },
    });
    await createUserDocument({
      userId,
      document: {
        name: documentName,
        type: type,
        documentFileKey: fileKey,
        comment,
      },
    });
  };

  return { uploadAndCreateUserDocument, isPending };
};
